<div class="carousel" data-test="carousel">
  <div
    class="heading-container"
    [ngClass]="border"
    data-test="carousel-container"
  >
    <p
      class="heading-text"
      data-test="carousel-heading-text"
    >{{headingText}}</p>
    <div class="scroll-control" *ngIf="showScroll$">
      <span class="svg-vertical-align-text-bottom" (click)="scroll('left')"><flo-svg-icon icon="icon-chevron-left" width="1em"></flo-svg-icon></span>
      <span class="svg-vertical-align-text-bottom" (click)="scroll('right')"><flo-svg-icon icon="icon-chevron-right" width="1em"></flo-svg-icon></span>
    </div>
  </div>
  <div
    #scrollContainer
    class="horizontal-scroll"
    floAnalytics
    events="scroll"
    eventName="Carousel Navigated"
  >
    <div class="content-container" data-test="carousel-content-container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
